import { createAutoCorrectedDatePipe, createNumberMask, emailMask } from 'text-mask-addons';
export { emailMask as email } from 'text-mask-addons';
export const SIN = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]; // Social Insurance Number
export const SSN = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // Social Security Number
export const ITIN = (rawInput) => {
    const mask = ['9', /\d/, /\d/, '-', /[5-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    const fourthNumber = rawInput.split('')[4];
    const setFiveNumberInMask = (value) => {
        mask[5] = value;
    };
    switch (fourthNumber) {
        case '5':
            setFiveNumberInMask(/[0-9]/);
            break;
        case '6':
            setFiveNumberInMask(/[0-5]/);
            break;
        case '7':
            setFiveNumberInMask(/[0-9]/);
            break;
        case '8':
            setFiveNumberInMask(/[0-8]/);
            break;
        case '9':
            setFiveNumberInMask(/[0-2]|[4-9]/);
            break;
    }
    return mask;
}; // Individual Taxpayer Identification Number
export const EIN = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]; // Employer Identification Number
export const PTIN = (rawInput) => {
    var _a;
    const digitsLength = ((_a = rawInput.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const numbersPartMask = new Array(digitsLength >= 11 ? 11 : digitsLength + 1).fill(/\d/);
    const finalMask = ['P'].concat(numbersPartMask);
    return finalMask;
}; // Preparer Tax Identification Number
export const Date = {
    // @ts-ignore
    pipe: createAutoCorrectedDatePipe('mm/dd/yyyy', { minYear: 1900, maxYear: 3000 }),
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
};
export const MonthYearDate = {
    // @ts-ignore
    pipe: createAutoCorrectedDatePipe('mm/yyyy', { minYear: 1900, maxYear: 3000 }),
    mask: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
};
export const Time12 = (rawInput) => {
    const mask = [/[0-1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /A|P/, 'M'];
    const digits = rawInput.match(/\d/g);
    let firstDigit;
    if (digits && digits.length) {
        firstDigit = digits[0];
    }
    if (firstDigit === '1') {
        mask[1] = /[0-2]/;
    }
    return mask;
};
export const USD = createNumberMask({
    decimalLimit: 2,
    allowDecimal: true,
    requireDecimal: true,
    thousandsSeparatorSymbol: ','
});
export const USDOptionalDecimal = createNumberMask({
    decimalLimit: 2,
    allowDecimal: true,
    thousandsSeparatorSymbol: ','
});
export const percent = createNumberMask({
    suffix: '%',
    prefix: '',
    decimalLimit: 7,
    allowDecimal: true,
    thousandsSeparatorSymbol: ''
});
// example: 123,456,789
export const noDecimals = createNumberMask({
    allowDecimal: false,
    thousandsSeparatorSymbol: ',',
    prefix: ''
});
export const CRD = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]; // Central Registration Depository
export const SEC = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]; // Standard Entry Class
export const phoneUS = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const phoneCA = [
    '1',
    '-',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/
];
export const phoneMX = [
    '+52',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/
];
export default {
    SIN,
    SSN,
    ITIN,
    EIN,
    PTIN,
    Date,
    MonthYearDate,
    Time12,
    USD,
    USDOptionalDecimal,
    percent,
    CRD,
    SEC,
    phoneUS,
    phoneCA,
    phoneMX,
    email: emailMask,
    noDecimals
};
